export const iconFontAwesomeBuildingsHouseMedicalFlag = (
	<i className="fa-solid fa-house-medical-flag"></i>
);
